module.exports = "/timeclock/directives/timesheetsReportColumn-10d55e.html";